<template>
    <csv-upload-card :validator="groupsCsvValidator" @selected="emit('selected', $event)" />
</template>

<script lang="ts" setup>
import CsvUploadCard from '~/components/general/CsvUploadCard.vue';
import { groupsCsvValidator } from './validateGroupsCsv';

const emit = defineEmits<{
    selected: [file: File];
}>();
</script>
